/**
 * Brand Colors
 */
export const colors = {
  /* Primary Colors */
  primary: '#3d57ff',
  secondary: '#2dc5b8',
  /* Status Colors */
  error: '#d82f2e',
  errorBorder: '#dbb1b1',
  errorBackground: '#fff0f0',
  success: '#26d162',
  warning: '#f39516',
  warningOrange: '#e66a00',
  /* Text & Icons */
  text: {
    icon: '#898c9a',
    link: '#3d57ff',
    primary: '#1f2532',
    placeholder: '#6a6e7c',
    secondary: '#6a6e7c',
  },
  /* Design Elements */
  background: {
    active: '#ebf5ff',
    dark: '#1f2532',
    error: '#d82f2f',
    light: '#f2f4f9',
  },
  border: '#dcdfe5',
  borderAction: '#888ca5',
  borderFocus: '#3d57ff',
  graphLine: '#cccfd6',
  white: '#fff',
  tickmark: '#8fc640',
  /* Data Visualization */
  data: {
    negative: '#c7343e',
    primary: '#2d1d81',
    secondary: '#1f2532',
    positive: '#039ca5',
    tertiary: ['#fae179', '#ff8162', '#3d57ff'], // also referred to as tertiary A, B, & C
  },
  /* Booking Status */
  bookingStatus: {
    blocked: '#dcdfe5',
    confirmed: '#5db322',
    confirmedLight: '#dff0d3',
    pending: '#fb8e3b',
    pendingLight: '#fdd2b1',
    scheduled: '#54c7ef',
  },
  /* Purple Shades for Graphs */
  graphShades: {
    10: '#dfdcea',
    20: '#dad7e7',
    30: '#cec9e1',
    40: '#c0b9d9',
    50: '#9f95c7',
    60: '#7f6fb5',
    70: '#6b59ab',
    80: '#4f379c',
    85: '#41298d',
    90: '#350d90',
    100: '#1f065c',
  },
  /* Net Promoter Score */
  nps: {
    detractor: '#f66f78',
    passive: '#ffcb89',
    promoter: '#01cba6',
  },
  /* Gray Shades */
  grays: {
    10: '#f2f4f9',
    20: '#dcdfe5',
    30: '#cccfd6',
    40: '#aaafb7',
    50: '#9196a1',
    60: '#707583',
    70: '#585e6d',
    80: '#4b5161',
    90: '#3a4152',
    100: '#141517',
  },
  /* Markdown Pill colors for AI Insights */
  aiInsights: {
    arrowUp: '#0DC170',
    arrowDown: '#D80202',
  },
};

/**
 * Brand Neutral Colors
 */
export const brandNeutralColors = {
  background: {
    light: '#f2f2f2',
  },
  border: '#e6e6e6',
  borderAction: '#949494',
  text: {
    icon: '#8c8c8c',
    placeholder: '#757575',
    primary: '#333333',
    secondary: '#6e6e6e',
  },
  white: '#fff',
};

export const gradients = {
  primary: 'linear-gradient(to bottom, #2dc5b8, #3d57ff)',
  blueGreen: 'linear-gradient(90deg, #242448 0%, #2dc5b8 100%)',
  highlight: 'linear-gradient(90deg, #2dc5b8 0%, #3d57ff 100%)',
  purpleRed: 'linear-gradient(90deg, #242448 0%, #f2424f 100%)',
};

export const overlays = { primary: 'rgba(31, 37, 50, 0.6)' };

export const shadows = { primary: '0 4px 10px 5px rgba(31, 37, 50, 0.1)' };

export const shape = { borderRadius: '4px' };
